import apiClient from './config';

export default {
  // Récupérer toutes les promotions
  getAll() {
    return apiClient.get('/promotions');
  },

  getAllPromotions() {
    return apiClient.get('/promotions');
  },

  // Récupérer les promotions actives
  getActives() {
    return apiClient.get('/promotions/actives');
  },

  getActivePromotions() {
    return apiClient.get('/promotions/actives');
  },

  // Récupérer une promotion spécifique
  getById(id) {
    return apiClient.get(`/promotions/${id}`);
  },

  getPromotion(id) {
    return apiClient.get(`/promotions/${id}`);
  },

  // Créer une nouvelle promotion
  create(data) {
    return apiClient.post('/promotions', data);
  },

  createPromotion(data) {
    return apiClient.post('/promotions', data);
  },

  // Modifier une promotion
  update(id, data) {
    return apiClient.put(`/promotions/${id}`, data);
  },

  updatePromotion(id, data) {
    return apiClient.put(`/promotions/${id}`, data);
  },

  // Supprimer une promotion
  delete(id) {
    return apiClient.delete(`/promotions/${id}`);
  },

  deletePromotion(id) {
    return apiClient.delete(`/promotions/${id}`);
  },

  // Activer/désactiver une promotion
  toggle(id) {
    return apiClient.post(`/promotions/${id}/toggle`);
  },

  togglePromotion(id) {
    return apiClient.post(`/promotions/${id}/toggle`);
  },

  // Valider un code promo
  validateCode(code) {
    return apiClient.post('/promotions/validate-code', { code });
  },

  // Récupérer les promotions publiques d'un salon
  getByFirm(firmId) {
    return apiClient.get(`/promotions/firm/${firmId}`);
  }
};
